module.exports = __webpack_public_path__ + "img/pr-3.00fb2627.png";